import { socketAsFetch } from 'utils/socket-as-fetch';

const ACCEPT_PRIVACY_POLICY_TYPE: string = 'accept_member_terms';

export const acceptUserTerms = (version: string) =>
  socketAsFetch({
    message_type: ACCEPT_PRIVACY_POLICY_TYPE,
    info: {
      version,
    },
  });
